import CoinDetails from './CoinDetails';

export default CoinDetails;